import AppRoutes from './app-routes.svelte';

const app = new AppRoutes({
  target: document.body,
  props: {}
});

export default app;
